import React from 'react';
import PropTypes from 'prop-types';
import { RichText } from 'prismic-reactjs';
import { graphql, StaticQuery } from 'gatsby';
import ReactHtmlParser from 'react-html-parser';

import Link from '../../../Core/Link';

import social from './data/social.json';
import {
  Wrapper,
  StyledContainer,
  Content,
  Sidebar,
  Departments,
  SocialLinks,
} from './styles';

// * Careers {arr} all the job posts as provideded by lever
// * social {arr} array of data for each social icon data is coming from data/social.json
// * Data {obj} all the data for the section provided by prismic
const CareersSection = ({ sectionId, data, careers, url, jobFilters }) => {
  if (!data) return null;
  const { titleHtml, bodyTextHtml, sectionTitle } = data;

  // * Take all the careers and create a list out of the departments. List must be unique
  const departments = careers.jobs.reduce(
    (acc, { categories: { department } }) => {
      if (!acc.includes(department)) acc.push(department);
      return acc;
    },
    []
  );

  return (
    <Wrapper>
      <StyledContainer id={sectionId} className="auto-margin">
        <Content>
          {ReactHtmlParser(titleHtml)}
          {ReactHtmlParser(bodyTextHtml)}
        </Content>
        <Sidebar>
          <div className="departments-container">
            <p>{RichText.asText(sectionTitle)}</p>
            <Departments className="no-bullets">
              {departments.map(department => {
                return (
                  <li key={`${department}`}>
                    <Link
                      to={`/${url}/${
                        jobFilters.id
                      }/?departmentQuery=${encodeURIComponent(department)}`}
                    >
                      {department}
                    </Link>
                  </li>
                );
              })}
            </Departments>
          </div>
          <SocialLinks>
            <p>Prodigy Careers on Social Media</p>
            <div className="social-icons-container">
              {social.socialShare.map(({ link, icon }) => {
                return (
                  <Link key={`social-share-${link.url}`} to={link.url}>
                    <img src={icon.url} alt={icon.altTag} />
                  </Link>
                );
              })}
            </div>
          </SocialLinks>
        </Sidebar>
      </StyledContainer>
    </Wrapper>
  );
};

CareersSection.propTypes = {
  data: PropTypes.shape().isRequired,
  sectionId: PropTypes.string.isRequired,
  careers: PropTypes.shape().isRequired,
  url: PropTypes.string.isRequired,
  jobFilters: PropTypes.string.isRequired,
};

const withStaticCareersSection = ({ data }) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          prodigy {
            careers {
              type
              jobs
            }
            jobFilters {
              id
            }
            pages(pageName: "jobs") {
              id
              lang
            }
          }
        }
      `}
      render={({ prodigy }) => (
        <CareersSection
          data={data}
          jobFilters={prodigy.jobFilters}
          careers={prodigy.careers}
          url={prodigy.pages[0].id}
          socialShare={prodigy.socialShare}
        />
      )}
    />
  );
};

withStaticCareersSection.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default withStaticCareersSection;
